import Vue from 'vue';
import axios from 'axios';
import mensaje from '../../../panel/mixins/mensaje';
import VueTheMask from 'vue-the-mask';

axios.defaults.baseURL = '/api';

Vue.use(VueTheMask);

let app = new Vue({
    el: '#app',
    mixins: {
        mensaje,
    },
    data() {
        return {

        }
    }
});
